module.exports = __webpack_public_path__ + "img/special-photo-01.299f5493.jpg";